import { Routes } from '@angular/router';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { adminGuard } from 'src/core/guards';
import { assessmentsRoutesNames } from './assessments.routes.names';

export const assessmentsRoutes: Routes = [
  {
    path: '',
    providers: [provideCharts(withDefaultRegisterables())],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('src/app/components/assessments/assessments.component').then(
            (module) => module.AssessmentsComponent,
          ),
        title: 'page-titles.assessments',
      },
      {
        path: assessmentsRoutesNames.ADMIN,
        redirectTo: assessmentsRoutesNames.ADMIN + '/questionnaires',
        title: 'page-titles.admin',
      },
      {
        canMatch: [adminGuard],
        path: assessmentsRoutesNames.ADMIN + '/overview',
        loadComponent: () =>
          import('src/app/components/assessments/admin/overview/overview.component').then(
            (module) => module.AssessmentsAdminOverviewComponent,
          ),
        title: 'page-titles.admin-overview',
      },
      {
        canMatch: [adminGuard],
        path: assessmentsRoutesNames.ADMIN + '/questionnaires',
        loadComponent: () =>
          import('src/app/components/assessments/admin/questionnaires-overview/questionnaires-overview.component').then(
            (module) => module.AssessmentsAdminQuestionnairesOverviewComponent,
          ),
        title: 'page-titles.admin-questionnaires',
      },
      {
        canMatch: [adminGuard],
        path: assessmentsRoutesNames.ADMIN + '/export/:questionnaireUuid',
        loadComponent: () =>
          import('src/app/components/assessments/admin/export/export.component').then(
            (module) => module.AssessmentsAdminExportComponent,
          ),
        title: 'page-titles.admin-export',
      },
      {
        canMatch: [adminGuard],
        path: assessmentsRoutesNames.ADMIN + '/:questionnaireUuid',
        loadComponent: () =>
          import('src/app/components/assessments/admin/admin.component').then(
            (module) => module.AssessmentsAdminComponent,
          ),
        title: 'page-titles.admin',
      },
      {
        canMatch: [adminGuard],
        path: assessmentsRoutesNames.ADMIN + '/statistics/:questionnaireUuid',
        loadComponent: () =>
          import('src/app/components/assessments/admin/statistics/statistics.component').then(
            (module) => module.AssessmentsAdminStatisticsComponent,
          ),
        title: 'page-titles.admin',
      },
      {
        path: ':assessmentUuid',
        loadComponent: () =>
          import('src/app/components/assessments/assessments.component').then(
            (module) => module.AssessmentsComponent,
          ),
        title: 'page-titles.assessments',
      },
      {
        path: ':assessmentUuid/intro',
        loadComponent: () =>
          import('src/app/components/assessments/intro/assessment.intro.component').then(
            (module) => module.AssessmentIntroComponent,
          ),
        title: 'page-titles.assessments',
      },
      {
        path:
          ':assessmentUuid/' + assessmentsRoutesNames.STAGES + '/:stageUuid',
        loadComponent: () =>
          import('src/app/components/assessments/assessments.component').then(
            (module) => module.AssessmentsComponent,
          ),
        title: 'page-titles.assessments',
      },
      {
        path:
          ':assessmentUuid/' +
          assessmentsRoutesNames.STAGES +
          '/:stageUuid/' +
          assessmentsRoutesNames.CATEGORIES +
          '/:categoryUuid',
        loadComponent: () =>
          import('src/app/components/assessments/assessments.component').then(
            (module) => module.AssessmentsComponent,
          ),
        title: 'page-titles.assessments',
      },
    ],
  },
];
